export default {
  SEND_FORGOT_PASSWORD_EMAIL: 'SEND_FORGOT_PASSWORD_EMAIL',
  SEND_FORGOT_PASSWORD_EMAIL_RESPONSE: 'SEND_FORGOT_PASSWORD_EMAIL_RESPONSE'
}
